module.exports = {"433122102":"达岚镇","433122104":"兴隆场镇","433122105":"潭溪镇","433122106":"洗溪镇","433122107":"武溪镇","433122108":"浦市镇","433122109":"合水镇","433122203":"石榴坪乡","433122206":"解放岩乡","433122207":"小章乡","433122208":"白羊溪乡","433122400":"军亭界林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/433122.json
// module id = 1767
// module chunks = 0